// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';
import { Order } from './interfaces';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class OrderService {
  public static getOrderNumbersString(orders: Order[]) {
    if (!orders.length) return '';

    const stringorders: string[] = [];
    orders.forEach((order) => stringorders.push(order.number));

    return stringorders.join(', ');
  }

  public static getOrderFactoryNumbers(orders: Order[]) {
    if (!orders.length) return null;

    const stringorders: string[] = [];
    orders.forEach((order) => stringorders.push(order.factoryNumber));

    return stringorders.join(', ');
  }

  public static getOrderWarehouseCodes(orders: Order[]) {
    if (!orders.length) return null;

    const stringorders: string[] = [];
    orders.forEach((order) => stringorders.push(order.warehouseCode));

    return stringorders.join(', ');
  }

  public static getFactWeightSum(orders: Order[], location: string) {
    return orders.filter((x) => x.locationName === location && x.factWeight).reduce((acc, i) => acc + i.factWeight, 0);
  }

  public static getFactWeightGrouped(orders: Order[]) {
    if (!orders.length) return null;
    const keys = Array.from(orders.reduce((acc, x) => acc.set(x.locationName, null), new Map()).keys());
    const sums = keys.map((l) => ({ l, weight: this.getFactWeightSum(orders, l) }));

    const grouped = sums
      .filter((x) => x.weight)
      .reduce((s, x) => `${parseFloat((x.weight / 1000).toFixed(3)).toString()} ${x.l}; ${s}`, '');
    return grouped;
  }

  public static async getOrderWeight(orders: string) {
    if (!orders.length) return '';
    try {
      const url = '/Orders/Weight';
      const response: AxiosResponse<number> = await axios.post(url, orders);

      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async getTripOrders(body: FormData) {
    try {
      const url = '/Orders/TryFind';
      const response: AxiosResponse<any> = await axios.post(url, body);

      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async getOrderPartNum(body: FormData) {
    try {
      const url = '/Orders/FindOrderPart';
      const response: AxiosResponse<any> = await axios.post(url, body);

      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async deleteTripOrder(body: any) {
    try {
      const url = `/Orders/Part/?Number=${body.number}&IsInputError=${body.isInputError}&IsDeleted=${body.isDeleted}&TripId=${body.tripId}`;
      const response: AxiosResponse<any> = await axios.delete(url);

      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }
}
